import { Dispatch, useCallback, useEffect, useRef, useState } from 'react'
import {
    CircularProgress,
    MenuItem,
    Select,
    Tooltip,
    Input as MaterialInput,
} from '@material-ui/core'
import { CheckIcon, FilterIcon } from '../_icons/Icons'
import styles from './Inputs.module.scss'
import clsx from 'clsx'
import CurrencyFormat from 'react-currency-format'
import { makeStyles } from '@material-ui/core/styles'
import { Checkbox } from '@material-ui/core'
import TextField from '@material-ui/core/TextField'
import { COUNTRY_CODES, STATE_CODES } from '../../consts'
import PhoneInput from 'react-phone-input-2'
import { formatMoney } from '../../utils'
import { DatePicker } from '@progress/kendo-react-dateinputs'
// import ReactInputDateMask from './ReactInputDateMask/ReactInputDateMask'
import InputMask from 'react-input-mask'
import { markRowInvalid, markRowValid } from '../../features/order/orderSlice'
import { useAppDispatch } from '../../app/hooks'
import { EditPencil } from '../_icons/Icons'
import { SvgIcon } from '@progress/kendo-react-common'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup, {
    ToggleButtonGroupPropsColorOverrides,
} from '@mui/material/ToggleButtonGroup'
import { OverridableStringUnion } from '@mui/types'

export enum BUTTON_TYPES {
    LINK = 'LINK',
    DISABLED = 'DISABLED',
    PRIMARY = 'PRIMARY',
    SECONDARY = 'SECONDARY',
    BLUE = 'BLUE',
}

interface ToggledInputProps {
    onChange(value: string): void
    editTestId?: string
    doneTestId?: string
    activeText?: string
    value?: string
    activeTextStyle?: React.CSSProperties
    inactiveTextStyle?: React.CSSProperties
    textAlign?: 'left' | 'right' | 'center'
    disabled?: boolean
}
export const ToggledInput = (props: ToggledInputProps) => {
    const {
        activeText = 'Done',
        editTestId,
        doneTestId,
        onChange,
        activeTextStyle = {},
        inactiveTextStyle = {},
        textAlign,
        disabled = false,
        //...otherProps
    } = props
    const [editing, setEditing] = useState(false)
    const [value, setValue] = useState(props.value || '')
    const ref = useRef<any>()

    useEffect(() => {
        if (editing) {
            ref.current && ref.current.focus()
        } else {
            setValue(props.value || '')
        }
    }, [editing, props.value])

    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter' || event.key === 'Tab') {
            handleEditDone()
        }
    }

    const handleEditDone = () => {
        onChange(value)
        setEditing(false)
    }

    return (
        <div>
            {!editing && (
                <div
                    style={
                        textAlign === 'right'
                            ? { display: 'flex', justifyContent: 'end' }
                            : textAlign === 'center'
                            ? { display: 'flex', justifyContent: 'center' }
                            : { display: 'flex' }
                    }
                >
                    <div
                        className={styles.lightText}
                        style={{
                            // paddingRight: 100,
                            maxWidth: 370,
                            overflow: 'hidden',
                            ...inactiveTextStyle,
                        }}
                        data-testid='value'
                    >
                        {value || ''}
                    </div>
                    {!disabled && (
                        <AWCButton
                            type={'link'}
                            data-testid={editTestId}
                            onClick={() => {
                                setEditing(true)
                            }}
                            style={{ marginLeft: value ? 10 : 0, ...inactiveTextStyle }}
                        >
                            <SvgIcon
                                icon={EditPencil}
                                height={12}
                                style={{
                                    cursor: 'pointer',
                                    paddingLeft: 2,
                                    paddingBottom: 2,
                                }}
                            />
                        </AWCButton>
                    )}
                </div>
            )}
            {editing && (
                <MaterialInput
                    onBlur={(event: any) => {
                        event.target.blur()
                        handleEditDone()
                    }}
                    inputRef={ref}
                    inputProps={{ maxLength: 25 }}
                    style={{ minWidth: '100%', ...activeTextStyle }}
                    required
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setValue(e.currentTarget.value)
                    }}
                    onFocus={() => {
                        ref.current && ref.current.select()
                    }}
                    onKeyDown={handleKeyDown}
                    value={value}
                    data-testid='editing'
                    endAdornment={
                        <AWCButton
                            type={BUTTON_TYPES.LINK}
                            data-testid={doneTestId}
                            onClick={() => {
                                onChange(value)
                                setEditing(false)
                            }}
                            style={{ marginLeft: 'auto' }}
                        >
                            {activeText}
                        </AWCButton>
                    }
                />
            )}
        </div>
    )
}

const BUTTON_CLASSES: Record<BUTTON_TYPES, string> = {
    LINK: 'actionText',
    DISABLED: 'a-disabled-button',
    PRIMARY: 'a-button',
    SECONDARY: 'a-cancel-button',
    BLUE: 'a-blue-button',
}
interface AWCButtonProps {
    onClick(e: React.MouseEvent<HTMLDivElement, MouseEvent>): void
    style?: React.CSSProperties | undefined
    type?: BUTTON_TYPES | Lowercase<`${BUTTON_TYPES}`>
    selected?: boolean
    tabIndex?: number
    children: any
}
export const AWCButton = (props: AWCButtonProps) => {
    const {
        type = BUTTON_TYPES.PRIMARY,
        children,
        onClick,
        selected,
        tabIndex,
        ...otherProps
    } = props

    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            type !== 'disabled' && onClick && onClick(event)
        }
    }
    let key = type.toUpperCase() as keyof typeof BUTTON_CLASSES
    return (
        <div
            className={clsx([
                selected && type !== 'disabled' && 'a-selected-button',
                BUTTON_CLASSES[key],
            ])}
            onKeyDown={handleKeyDown}
            onClick={(e) => type !== 'disabled' && onClick && onClick(e)}
            tabIndex={tabIndex ? tabIndex : 0}
            {...otherProps}
        >
            {selected && <CheckIcon />}

            {children}
        </div>
    )
}

export const CustomDateInput = (props: any) => {
    let tempMonth, tempDay, tempYear
    if (props.value) {
        tempMonth = (props.value.getMonth() + 1).toString()
        tempMonth = tempMonth.length > 1 ? tempMonth : '0' + tempMonth

        tempDay = props.value.getDate().toString()
        tempDay = tempDay.length > 1 ? tempDay : '0' + tempDay

        tempYear = props.value.getFullYear()
    }

    useEffect(() => {
        document.addEventListener('keydown', props.keyPressed, false)

        return () => {
            document.removeEventListener('keydown', props.keyPressed, false)
        }
    }, [])

    return (
        <div
            className={styles.dateInput}
            style={{
                display: 'contents',
            }}
        >
            <InputMask
                mask='99/99/9999'
                // defaultValue="mm/dd/yyyy"
                placeholder=''
                defaultValue={props.value ? tempMonth + '/' + tempDay + '/' + tempYear : ''}
                className={styles.reactInputDateMask}
                onFocus={(e) => e.target.select()}
            />
        </div>
    )
}

// export const CustomDateInput = (props: any) => {

//     let tempMonth, tempDay, tempYear
//     if (props.value) {
//         tempMonth = (props.value.getMonth() + 1).toString()
//         tempMonth = tempMonth.length > 1 ? tempMonth : '0' + tempMonth

//         tempDay = props.value.getDate().toString()
//         tempDay = tempDay.length > 1 ? tempDay : '0' + tempDay

//         tempYear = props.value.getFullYear()
//     }
//     return (
//         <div
//             className={styles.dateInput}
//             style={{
//                 display: 'contents',
//             }}
//         >
//             <ReactInputDateMask
//                 mask="mm/dd/yyyy"
//                 className={styles.reactInputDateMask}
//                 value={props.value ? tempMonth + '/' + tempDay + '/' + tempYear : ''}
//             />
//         </div>
//     )
// }

const useStyles = makeStyles({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: 'var(--linkblue)',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.2),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 18%,transparent 12%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: 'var(--linkblue)',
        },
    },
})
export const StateDropdownList = (props: any) => {
    let { validationText, title, style, ...otherProps } = props
    return (
        <div className={styles.inputContainer} style={style}>
            {/* todo make uniform */}
            <div style={{ whiteSpace: 'nowrap', height: 23, marginTop: -23 }}>
                {title && <span className={styles.inputTitle}>{title}</span>}
                {validationText && (
                    <div className={styles.inputValidationText}>{validationText}</div>
                )}
            </div>
            <Select
                variant='outlined'
                MenuProps={{ MenuListProps: { classes: { root: styles.list } } }}
                displayEmpty
                style={{ width: '100%' }}
                // renderValue={(value: any) => (STATE_CODES as any)[value] ? (STATE_CODES as any)[value] : "Select State"}
                {...otherProps}
                data-testid={props.testid}
            >
                <MenuItem key='none' value=''>
                    State
                </MenuItem>
                {Object.entries(STATE_CODES).map((keyValue) => {
                    let [key, value] = keyValue
                    //STATE_CODES has codes for keys so this looks backwards
                    return (
                        <MenuItem key={key} value={key}>
                            {value}
                        </MenuItem>
                    )
                })}
            </Select>
        </div>
    )
}

export const CountryDropdownList = (props: any) => {
    let { validationText, title, style, ...otherProps } = props

    return (
        <div className={styles.inputContainer} style={style}>
            <div style={{ whiteSpace: 'nowrap', height: 23, marginTop: -23 }}>
                {title && <span className={styles.inputTitle}>{title}</span>}
                {validationText && (
                    <div className={styles.inputValidationText}>{validationText}</div>
                )}
            </div>
            <Select
                variant='outlined'
                MenuProps={{ MenuListProps: { classes: { root: styles.list } } }}
                {...otherProps}
                style={{ width: '100%', maxWidth: 280 }}
                displayEmpty
                data-testid={props.testid}
            >
                <MenuItem key='none' value=''>
                    <em>Country</em>
                </MenuItem>
                {Object.entries(COUNTRY_CODES).map((keyValue) => {
                    let [key, value] = keyValue
                    //STATE_CODES has codes for keys so this looks backwards
                    return (
                        <MenuItem key={key} value={key}>
                            {value}&nbsp;&nbsp;&nbsp;
                        </MenuItem>
                    )
                })}
            </Select>
        </div>
    )
}

export const FastQuoteDropdownList = (props: any) => {
    let {
        validationText,
        title,
        value,
        selectList,
        onChange,
        showConfirmOnly,
        editingShippingOption,
        ...otherProps
    } = props

    return (
        <div className={styles.inputContainer}>
            {/* <div style={{ whiteSpace: 'nowrap', height: 23, marginTop: -23 }}>
                {title && <span className={styles.inputTitle}>{title}</span>}
                {validationText && (
                    <div className={styles.inputValidationText}>{validationText}</div>
                )}
            </div> */}
            <Select
                variant='outlined'
                MenuProps={{ MenuListProps: { classes: { root: styles.list } } }}
                {...otherProps}
                style={{ width: '100%', backgroundColor: 'white' }}
                displayEmpty
                disabled={editingShippingOption === 'Custom' ? false : true}
                value={value}
                onChange={onChange}
            >
                <MenuItem value={'' || 0}>
                    <em>Select One</em>
                </MenuItem>

                {selectList &&
                    selectList.map((keyValue: any) => {
                        let key = keyValue[0]
                        let value = keyValue[1]
                        let description

                        if (title === 'Service') {
                            description = keyValue[2]
                        }

                        switch (title) {
                            case 'Service':
                                return (
                                    <MenuItem value={key}>
                                        <Tooltip title={description}>
                                            <span>{value}</span>
                                        </Tooltip>
                                    </MenuItem>
                                )

                            case 'Terms':
                                if (showConfirmOnly) {
                                    return <MenuItem value={key}>{value}</MenuItem>
                                } else {
                                    if (key !== 6) {
                                        return <MenuItem value={key}>{value}</MenuItem>
                                    }
                                }
                                break
                            default:
                                // 'Carrier'
                                return <MenuItem value={key}>{value}</MenuItem>
                        }
                        return null
                    })}
            </Select>
        </div>
    )
}

export const DropdownList = (props: any) => {
    let { validationText, title, style, onChange, ...otherProps } = props
    return (
        <div className={styles.inputContainer} style={style}>
            {/* todo make uniform */}
            {(title || validationText) && (
                <div style={{ whiteSpace: 'nowrap', height: 23, marginTop: -23 }}>
                    {title && <span className={styles.inputTitle}>{title}</span>}
                    {validationText && (
                        <div className={styles.inputValidationText}>{validationText}</div>
                    )}
                </div>
            )}
            <Select
                variant='outlined'
                MenuProps={{
                    MenuListProps: { classes: { root: styles.list } },
                    getContentAnchorEl: null,
                    anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
                    transformOrigin: { vertical: 'top', horizontal: 'center' },
                }}
                displayEmpty
                style={{ width: '100%' }}
                // renderValue={(value: any) => (STATE_CODES as any)[value] ? (STATE_CODES as any)[value] : "Select State"}
                {...otherProps}
                data-testid={props.testid}
                onChange={onChange}
            >
                {props.children}
            </Select>
        </div>
    )
}

interface InputLoaderProps {
    style?: any
}
export const InputLoader = (props: InputLoaderProps) => {
    return (
        <CircularProgress
            className={styles.progress}
            classes={{ root: styles.progressContainer }}
            style={props.style || { height: 20, width: 20 }}
        />
    )
}
export function StyledRadio(props: any) {
    const classes = useStyles()
    return (
        <Checkbox
            className={classes.root}
            disableRipple
            color='default'
            checked={props.checked}
            value={props.value}
            onChange={(e) => {
                props.onChange && props.onChange(e.target.checked)
            }}
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            disabled={props.disabled}
            data-testid={props.testid}
        />
    )
}
export function StyledRadioSingleChoice(props: any) {
    const classes = useStyles()
    return (
        <Checkbox
            className={classes.root}
            disableRipple
            color='default'
            checked={props.checked}
            value={props.value}
            onChange={props.onChange}
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            disabled={props.disabled}
        />
    )
}
export const RadioButtonGroup = (props: any) => {
    const [value, setValue] = useState(props.defaultValue)
    return (
        <div style={{ display: 'flex', gap: 25 }}>
            <div style={{ display: 'flex', gap: 6 }}>
                <StyledRadio
                    checked={value === true}
                    onChange={(newVal: boolean) => {
                        if (!value) {
                            setValue(newVal)
                            props.onChange && props.onChange(newVal)
                        }
                    }}
                />
                <div>Yes</div>
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
                <StyledRadio
                    checked={value === false}
                    onChange={(newVal: boolean) => {
                        if (value) {
                            setValue(!newVal)
                            props.onChange && props.onChange(!newVal)
                        }
                    }}
                />
                <div>No</div>
            </div>
        </div>
    )
}
export const Input = (props: any) => {
    // pull any gridcolumn value out of style and take it from the direct prop gridColumn
    let { gridColumn, style, inputStyle, onFocus, ...otherProps } = props
    let { ...styleObject } = props.style || {}
    if (gridColumn) {
        styleObject.gridColumn = `span ${gridColumn}`
        styleObject.width = '100%'
    }

    const ref = useRef<any>()

    return (
        <TextField
            style={styleObject}
            inputProps={{ style: inputStyle }}
            onFocus={(e) => {
                e.target.select()
                onFocus && onFocus(e)
            }}
            ref={ref}
            classes={{ root: styles.fastQuoteInput }}
            variant='outlined'
            size='small'
            {...otherProps}
        />
    )
}

export const FilterInput = ({
    onChange,
    placeholder = 'Filter Addresses',
}: {
    placeholder?: string
    onChange: Dispatch<string>
}) => {
    return (
        <Input
            startAdornment={<FilterIcon />}
            placeholder={placeholder}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        />
    )
}
const isValidMoneyString = (rawString: string) => {
    if (!rawString) {
        return false
    }
    // return /^[0-9]{0,3}(?:,?[0-9]{3})*(?:\.[0-9]*)?$/.test(rawString)
    return /^[0-9]{1,3}(,?[0-9]{3}){0,2}(\.[0-9]{0,4})?$/.test(rawString)
}
export const MoneyInput = (props: any) => {
    const { rowId } = props
    const [rawValue, setRawValue] = useState(props.value)
    const [validate, setValidate] = useState(props.validate || false)

    useEffect(() => {
        if (!rawValue && rawValue !== 0) {
            dispatch(markRowInvalid({ rowId: rowId, field: 'UnitPrice' }))
        } else {
            dispatch(markRowValid({ rowId: rowId, field: 'UnitPrice' }))
        }
    }, [rawValue])
    const dispatch = useAppDispatch()
    useEffect(() => {
        setRawValue(props.value !== undefined ? `${formatMoney(props.value)}` : '')
    }, [props.value])
    return (
        <div className={styles.moneyInput}>
            <CurrencyFormat
                value={rawValue}
                variant={'outlined'}
                onChange={(e) => {
                    setRawValue(e.target.value)
                }}
                useNativeOnChange={true}
                thousandSeparator={true}
                onBlur={(e) => {
                    if (props.onBlur) props.onBlur(e)
                    else {
                        if (isValidMoneyString(rawValue)) {
                            let moneyValue = parseFloat(
                                rawValue.replace('$', '').replaceAll(',', '')
                            )
                            props.onChange && props.onChange(moneyValue)
                            dispatch(markRowValid({ rowId, field: 'UnitPrice' }))
                            setRawValue(`${formatMoney(moneyValue)}`)
                        } else {
                            dispatch(markRowInvalid({ rowId, field: 'UnitPrice' }))
                        }
                    }
                }}
                customInput={FastQuoteInput}
                title={' '}
                // validationText={!isValidMoneyString(rawValue) && 'Invalid Price'}
            />
            {validate && (
                <div style={{ whiteSpace: 'nowrap', height: 23, marginTop: -5 }}>
                    {!isValidMoneyString(rawValue) && (
                        <div className={styles.inputValidationText}>Invalid Price</div>
                    )}
                </div>
            )}
        </div>
    )
}
export const OnBlurFastQuoteInput = (props: any) => {
    const { onChange, onBlur, validator, value: trash, ...otherProps } = props
    const [value, setValue] = useState('')
    const [lastValue, setLastValue] = useState<string | null>(null)
    useEffect(() => {
        // if passed a new value that is different than ours, update
        if (props.value !== lastValue) {
            setValue(props.value)
            setLastValue(props.value)
        }
    }, [props.value])
    return (
        <FastQuoteInput
            onChange={(newValue: string) => {
                if (!newValue) {
                    setValue('')
                    return
                }
                if (validator) {
                    validator(newValue) && setValue(newValue)
                } else {
                    setValue(newValue)
                }
            }}
            value={value}
            onBlur={(e: any, value: any) => onChange(value)}
            {...otherProps}
        />
    )
}
export const OnBlurDatePicker = (props: any) => {
    const { onChange, min, width } = props
    const [newDate, setNewDate] = useState<Date | null>(null)
    const [lastDate, setLastDate] = useState<Date | null>(null)
    const handleNeedDateKeyPressed = useCallback((event: any) => {
        if (event.keyCode === 13) {
            event.target.blur()
        }
    }, [])
    useEffect(() => {
        // if passed a new value that is different than ours, update
        if (props.value !== lastDate) {
            setNewDate(props.value)
            setLastDate(props.value)
        }
    }, [props.value])
    return (
        <DatePicker
            width={width}
            min={min}
            required
            onChange={onChange}
            value={newDate ? new Date(newDate) : null}
            onBlur={onChange}
            dateInput={(params: any) => (
                <CustomDateInput keyPressed={handleNeedDateKeyPressed} {...params} />
            )}
        />
    )
}
export const FastQuoteInput = (props: any) => {
    // TODO typescript
    let {
        placeholder,
        onBlur,
        onChange,
        Icon,
        title,
        validationText,
        defaultValue,
        infoText,
        value,
        loading,
        renderEndIcon,
        gridColumn,
        testid,
        style,
        editingShippingOption,
        useNativeOnChange,
        required,
        maxLength,
        autocomplete,
        tooltip,
        ...otherProps
    } = props

    let { ...styleObject } = props.style || {}
    if (gridColumn) {
        styleObject.gridColumn = `span ${gridColumn}`
        styleObject.width = '100%'
    }

    const [hitMax, setHitMax] = useState<boolean>(false)
    return (
        <div className={styles.inputContainer} style={styleObject}>
            {title && typeof title == 'function' ? (
                title()
            ) : (
                <div
                    style={{
                        whiteSpace: 'nowrap',
                        height: 23,
                        marginTop: -23,
                    }}
                >
                    <div className={styles.inputTitle}>
                        {title || ''}
                        {required && <span style={{ color: 'red', marginLeft: 3 }}>*</span>}
                    </div>
                    {validationText && (
                        <div className={styles.inputValidationText}>{validationText}</div>
                    )}
                    {maxLength && hitMax && (
                        <span style={{ color: 'var(--invalidText)', fontSize: '0.75em' }}>
                            {' '}
                            Max Length: {maxLength}
                        </span>
                    )}
                </div>
            )}
            {/* //TODO change icon to renderStartIcon so you can bring onClicks with it */}
            <Input
                InputProps={{
                    startAdornment: Icon && <Icon />,
                    endAdornment: loading ? <InputLoader /> : renderEndIcon && renderEndIcon(),
                }}
                placeholder={placeholder}
                required={required}
                classes={{ root: styles.fastQuoteInputRoot }}
                defaultValue={defaultValue}
                value={value}
                title={tooltip}
                disabled={
                    editingShippingOption
                        ? editingShippingOption === 'Custom'
                            ? false
                            : true
                        : false
                }
                data-testid={testid}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    if (onChange) {
                        if (useNativeOnChange) {
                            if (e.target) {
                                let newValue = e.target.value
                                if (newValue.length > maxLength) setHitMax(true)
                                else {
                                    setHitMax(false)
                                    onChange(e)
                                }
                            }
                        } else {
                            if (e.target) {
                                let newValue = e.target.value
                                if (newValue.length > maxLength) setHitMax(true)
                                else {
                                    setHitMax(false)
                                    onChange(newValue)
                                }
                            } else {
                                onChange('')
                            }
                        }
                    }
                }}
                onBlur={(e: any) => {
                    onBlur && onBlur(e, value)
                }}
                {...otherProps}
            />
            {infoText && <div className={styles.infoText}>{infoText}</div>}
        </div>
    )
}

export const InternationalPhoneInput = (props: any) => {
    let {
        placeholder,
        onChange,
        onFocus,
        Icon,
        title,
        validationText,
        infoText,
        value,
        loading,
        renderEndIcon,
        gridColumn,
        style,
        useNativeOnChange,
        required,
        maxLength,
        testid,
        disabled = false,
        ...otherProps
    } = props

    let { ...styleObject } = props.style || {}
    if (gridColumn) {
        styleObject.gridColumn = `span ${gridColumn}`
        styleObject.width = '100%'
    }
    return (
        <div className={styles.inputContainer} style={styleObject}>
            {title &&
                (typeof title == 'function' ? (
                    title()
                ) : (
                    <div
                        style={{
                            whiteSpace: 'nowrap',
                            height: 23,
                            marginTop: -23,
                        }}
                    >
                        <div className={styles.inputTitle}>
                            {title}
                            {required && <span style={{ color: 'red', marginLeft: 3 }}>*</span>}
                        </div>
                        {validationText && (
                            <div className={styles.inputValidationText}>{validationText}</div>
                        )}
                    </div>
                ))}

            <PhoneInput
                placeholder={placeholder}
                country={'us'}
                value={value}
                onChange={onChange}
                autoFormat
                disabled={disabled}
                onFocus={onFocus}
                inputStyle={{ width: '100%', minHeight: 43 }}
                inputProps={{ 'data-testid': testid, disabled }}
                {...otherProps}
            />
            {infoText && <div className={styles.infoText}>{infoText}</div>}
        </div>
    )
}
interface ToggleButtonsProps {
    buttonText: [string, string]
    onChange?(selectedIndex: number): void
    selectedIndex?: number
    color?: OverridableStringUnion<
        'primary' | 'secondary' | 'error' | 'standard' | 'info' | 'success' | 'warning',
        ToggleButtonGroupPropsColorOverrides
    >
}

export const ToggleButtons = (props: ToggleButtonsProps) => {
    let { buttonText, onChange, selectedIndex, color } = { ...props }
    const [selectedButtonIndex, setSelectedButtonIndex] = useState(
        selectedIndex ? selectedIndex : 0
    )

    const handleChange = (event: React.MouseEvent<HTMLElement>, newSelectedIndex: number) => {
        if (newSelectedIndex == null) return

        setSelectedButtonIndex(newSelectedIndex)
        onChange && onChange(newSelectedIndex)
    }

    return (
        <ToggleButtonGroup
            color={color ? color : 'primary'}
            value={selectedButtonIndex}
            exclusive
            onChange={handleChange}
            className={styles.toggleButtons}
        >
            <ToggleButton value={0}>{buttonText[0]}</ToggleButton>
            <ToggleButton value={1}>{buttonText[1]}</ToggleButton>
        </ToggleButtonGroup>
    )
}
